import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postRefereeSignup } from '@arrived/api_v2';
import { ReferralCode } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { referralsQueryKeyFn } from './referrals.keys';

export function usePostRefereeSignupMutation(options?: UseMutationOptions<boolean, ReferralCode>) {
  const queryClient = useQueryClient();

  return useMutation((referralCode) => postRefereeSignup(referralCode), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(referralsQueryKeyFn(variables));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
